import OrderStatuses from '../enum/OrderStatuses';
import type { IOrder } from '../interfaces/Order';

export const STORE_RECEPTION_VALIDATION_QUERY_MODE = 'store-reception-validation';
export const STORE_RECEPTION_VALIDATION_UPDATE_MODE = 'store_reception_validation';

export const STORE_RECEPTION_VALIDATION_ALLOWED_STATUSES = [
  OrderStatuses.PICKUP,
  OrderStatuses.PICKINGUP,
  OrderStatuses.PENDING_STORE_RECEPTION_VALIDATION,
  OrderStatuses.CLEANING
] as const;

export const hasStoreReceptionValidationCompleted = (order?: Partial<IOrder> | null): boolean =>
  Boolean(order?.storeReceptionValidation?.validatedAt);

export const requiresRoutePickupCompletionBeforeStoreReceptionValidation = (
  order?: Partial<IOrder> | null
): boolean => order?.status === OrderStatuses.PICKINGUP && Boolean(order?.pickupRoute);

export const isStoreReceptionValidationEligibleOrder = (
  order?: Partial<IOrder> | null
): boolean => {
  if (!order || hasStoreReceptionValidationCompleted(order)) return false;
  if (requiresRoutePickupCompletionBeforeStoreReceptionValidation(order)) return false;

  const hasPickupOrDeliveryContext = Boolean(
    order.pickup || order.delivery || order.pickupRoute || order.deliveryRoute
  );

  return (
    hasPickupOrDeliveryContext &&
    STORE_RECEPTION_VALIDATION_ALLOWED_STATUSES.includes(order.status as any)
  );
};

export const canShowValidateStoreReceptionAction = ({
  order,
  canValidateStoreReception,
  storeReceptionValidationEnabled
}: {
  order?: Partial<IOrder> | null;
  canValidateStoreReception: boolean;
  storeReceptionValidationEnabled: boolean;
}): boolean => {
  return (
    storeReceptionValidationEnabled &&
    canValidateStoreReception &&
    isStoreReceptionValidationEligibleOrder(order)
  );
};

export const getOrderStoreId = (
  order?: Partial<IOrder> | null,
  fallbackStoreId = ''
): string => {
  const createdIn = order?.createdIn;
  if (typeof createdIn === 'string') return createdIn;
  return createdIn?._id || fallbackStoreId;
};
